module.exports = __webpack_public_path__ + "c08f5e99c33c9fcbdde64479cbfcb07c.pdf";